"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ratingCssConfig = exports["default"] = void 0;
var ratingCssConfig = exports.ratingCssConfig = {
  large: {
    height: 'var(--spacing-global-space6)',
    // Use rem values. Original height is 24px
    widthFallback: 'calc(var(--spacing-global-space6) * 4.8)',
    // width fallback value for browsers that don't support aspect ratio
    fontSize: '1',
    elementSpacing: '--spacing-space8',
    marginBottom: '-4px'
  },
  medium: {
    height: "".concat(Math.round(20 / 16 * 1.6 * 10) / 10, "rem"),
    // No variable to use for rem values hence multiplying by 1.6 due to root font-size of page being 10px and rounding to 1 decimal place. Original height is 20px
    widthFallback: "".concat(Math.round(20 / 16 * 1.6 * 4.8 * 10) / 10, "rem"),
    // width fallback value for browsers that don't support aspect ratio
    fontSize: 'm1',
    elementSpacing: '--spacing-space4',
    marginBottom: '-2px'
  },
  small: {
    height: 'var(--spacing-global-space5)',
    // Use rem values. Original height is 16px
    widthFallback: 'calc(var(--spacing-global-space5) * 4.8)',
    // width fallback value for browsers that don't support aspect ratio
    fontSize: 'm2',
    elementSpacing: '--spacing-space4',
    marginBottom: '-2px'
  }
};
var _default = exports["default"] = ratingCssConfig;